import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Home } from './features/shared/components/Home';
import { WhatsonList } from './features/whatson/components/WhatsonList';
import { FaqList } from './features/faq/components/FaqList';
import { WhatsonEntryForm } from './features/whatson/components/WhatsonEntryForm';
import { MainLayout } from './features/shared/components/MainLayout';
import { FaqEntryForm } from './features/faq/components/FaqEntryForm';
import { About } from './features/shared/components/About';
import { VendorList } from './features/vendor/components/VendorList';
import { VendorEntryForm } from './features/vendor/components/VendorEntryForm';
import { Conduct } from './features/shared/components/Conduct';
import { Splash } from './features/shared/components/Splash';
import { MakersMarket } from './features/shared/components/MakersMarket';

// use of the import "import { Home } from './features/shared/components/Home'"
// i.e., bypassing shared/components/index.ts caused the dreaded 'Cannot access [var] before initialization' error
// need to find out how/why this happened (looks like an easy error to make and very hard to troubleshoot)

/** ***Uncaught ReferenceError***
 * 
 * use of the import "import { Home } from './features/shared/components/Home'"
 * i.e., bypassing shared/components/index.ts caused the dreaded 'Cannot access [var] before initialization' error
 * need to find out how/why this happened (looks like an easy error to make and very hard to troubleshoot)
 * 
 * It happened again 25/09/05
 * If we include <EmailUsForm/> in both Splash.tsx and Home.tsx (see bottom of both components)
 * we get the dreaded: "Uncaught ReferenceError: Cannot access EmailUsForm before initialization"
 * 
 * Perhaps the use of /features/shared/components/indes.ts somehow produces a circular reference?
 */

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/splash-929292991928182182182' element={<Splash />} />
        <Route element={<MainLayout />}>
          <Route path='/' element={<Home />} />
          <Route path='whatson' element={<About />} />
          <Route path='conduct' element={<Conduct />} />
          <Route path='schedule' element={<WhatsonList />} />
          <Route path='schedule-add' element={<WhatsonEntryForm />} />
          <Route path='schedule-edit/:id' element={<WhatsonEntryForm />} />
          <Route path='faqs' element={<FaqList />} />
          <Route path='faq-add' element={<FaqEntryForm />} />
          <Route path='faq-edit/:id' element={<FaqEntryForm />} />
          <Route path='makersmarket' element={<MakersMarket />} />
          <Route path='vendorfaqs' element={<VendorList />} />
          <Route path='vendorfaq-add' element={<VendorEntryForm />} />
          <Route path='vendorfaq-edit/:id' element={<VendorEntryForm />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
